import React, { useState, useEffect, useCallback } from 'react';
import Datepicker from 'react-tailwindcss-datepicker';

const DateRangePicker = ({
  startDate,
  endDate,
  onStartDateChange,
  onEndDateChange,
  onDateRangeChange,
  className = '',
  disabled = false,
  placeholder = 'Select date range',
  label = {
    start: 'Join Date From',
    end: 'Join Date To',
  },
}) => {
  // Convert string dates to the format expected by react-tailwindcss-datepicker
  const [value, setValue] = useState({
    startDate: startDate || null,
    endDate: endDate || null,
  });

  // Update internal state when props change
  useEffect(() => {
    setValue({
      startDate: startDate || null,
      endDate: endDate || null,
    });
  }, [startDate, endDate]);

  const handleValueChange = useCallback(
    newValue => {
      console.log('DateRangePicker value changed:', newValue);
      setValue(newValue);

      // Call individual date change callbacks
      if (onStartDateChange && newValue.startDate !== value.startDate) {
        onStartDateChange(newValue.startDate);
      }

      if (onEndDateChange && newValue.endDate !== value.endDate) {
        onEndDateChange(newValue.endDate);
      }

      // Call the range change callback
      if (onDateRangeChange) {
        onDateRangeChange({
          startDate: newValue.startDate,
          endDate: newValue.endDate,
        });
      }
    },
    [value, onStartDateChange, onEndDateChange, onDateRangeChange]
  );

  return (
    <div className={className}>
      <label className='block text-sm font-medium text-gray-700 mb-2'>
        {label.start} - {label.end}
      </label>
      <div className='relative react-tailwindcss-datepicker-input'>
        <Datepicker
          value={value}
          onChange={handleValueChange}
          showShortcuts={true}
          showFooter={true}
          placeholder={placeholder}
          disabled={disabled}
          displayFormat='YYYY-MM-DD'
          primaryColor='blue'
          useRange={true}
          popoverDirection='down'
          inputClassName='block w-full pl-3 pr-10 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 disabled:bg-gray-50 disabled:text-gray-500 disabled:cursor-not-allowed datepicker-input-with-icon bg-white !text-gray-900'
          toggleClassName='cal-icon text-gray-400 hover:text-gray-600'
          containerClassName='relative'
        />
      </div>
    </div>
  );
};

export default DateRangePicker;
